// extracted by mini-css-extract-plugin
export default {"brand":"Brand_brand__dyvI5","product":"Brand_product__j9-0E"};